import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppContact extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer);
    ;
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", MachineAppTranslations);
    public data: MachineAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class MachineAppTranslations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}